/** Overlapping categories, one common base, bounded preview and complete native details. */
import * as z from 'zod';
import { insightCardHelpSchema, insightDisplayDatumSchema } from './insight-presentation.js';
export const insightCategoryBreakdownSchema = z
    .strictObject({
    kind: z.literal('category-breakdown'),
    id: z.string().regex(/^[a-z][a-z0-9-]{0,119}$/),
    title: z.string().min(1).max(120),
    state: z.enum(['ready', 'empty', 'unavailable']),
    message: z.string().min(1).max(700).nullable(),
    base: insightDisplayDatumSchema,
    rows: z.array(z.strictObject({
        key: z.string().min(1),
        label: z.string().min(1),
        count: insightDisplayDatumSchema,
        share: insightDisplayDatumSchema,
    })),
    previewRows: z.number().int().min(1).max(10),
    detailsLabel: z.string().min(1).max(120),
    footer: z.string().min(1).max(700),
    help: insightCardHelpSchema,
})
    .superRefine((r, ctx) => {
    if ((r.state === 'ready') !== r.rows.length > 0 ||
        (r.state === 'ready') !== (r.message === null) ||
        new Set(r.rows.map((row) => row.key)).size !== r.rows.length)
        ctx.addIssue({ code: 'custom', message: 'INSIGHT_PRESENTATION_INVALID: category breakdown state or identities' });
});
//# sourceMappingURL=insight-category-breakdown.js.map